<div id="driver-wizard" class="row ">
     <div class="d-flex justify-content-between align-items-center card-title" id="page-title">
          <h1 *ngIf="!service.justSubscribe" [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>
          
          <h1 *ngIf="service.justSubscribe" [innerHtml]="'RecordMonitoring' | translator: 'base'">
               Subscribe to Driver Monitoring
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="getStepForPercentComplete()" [totalSteps]="wizard.totalSteps"></app-complete-bar>
                    <h2 [innerHtml]="'ContactInformation' | translator: 'base'">Your PSP Record</h2>
                    <div class="justify-content-md-center form-group form-inline">

                         <p class="step-text"
                         [innerHtml]="'AddressPhoneHelp' | translator: 'base'">
                              Next, we'll need your address and phone number.
                         </p>

                         <div class="row">
                              <div class="col col-12 mb-3"
                                   [formGroup]="form">
                                   <label for="driverStreetAddress"
                                        class="form-label">
                                        <span [innerHtml]="'Street' | translator: 'base'">
                                             Street
                                        </span><span class="text-danger text-center ms-1"
                                             [title]="'Required' | translator: 'base'">*</span>
                                   </label>
                                   <input 
                                        formControlName="addressLine1"
                                        [title]="'Street' | translator: 'base'"
                                        class="bg-light form-control"
                                        type="text"
                                        id="driverStreetAddress"
                                        name="driverStreetAddress"
                                        required
                                        maxLength="100"
                                   />
                                   <span *ngIf="addressLine1!.invalid && addressLine1!.dirty"
                                        class="help-block text-danger">
                                        <span *ngIf="addressLine1!.errors?.['required']"
                                             [innerHtml]="'Address_required' | translator: 'base'">
                                             Address Line 1 is required.
                                        </span>
                                        <span *ngIf="addressLine1!.errors?.['pattern']"
                                             [innerHtml]="'AddressLineInvalid' | translator: 'base'">
                                             Address contains invalid value(s). Please use only letters, numbers,
                                             apostrophes and spaces.
                                        </span>
                                        <span *ngIf="addressLine1!.errors?.['maxlength']"
                                             [innerHtml]="'DriverAddress_max' | translator: 'base'">
                                             Address must be 100 characters or less.
                                        </span>
                                   </span>
                              </div>
                              <div class="col col-12 mb-3"
                                   [formGroup]="form">
                                   <label for="driverStreetAddress2"
                                        class="form-label">
                                        <span [innerHtml]="'Street2' | translator: 'base'">
                                             Street 2
                                        </span>
                                   </label>
                                   <input 
                                        formControlName="addressLine2"
                                        [title]="'Street2' | translator: 'base'"
                                        class="bg-light form-control"
                                        type="text"
                                        id="driverStreetAddress2"
                                        name="driverStreetAddress2"
                                        maxLength="100"
                                   />
                                   <span *ngIf="addressLine2!.invalid && addressLine2!.dirty"
                                        class="help-block text-danger">
                                        <span *ngIf="addressLine2!.errors?.['pattern']"
                                             [innerHtml]="'AddressLineInvalid' | translator: 'base'">
                                             Address contains invalid value(s). Please use only letters, numbers,
                                             apostrophes and spaces.
                                        </span>
                                        <span *ngIf="addressLine2!.errors?.['maxlength']"
                                             [innerHtml]="'DriverAddress_max' | translator: 'base'">
                                             Address must be 100 characters or less.
                                        </span>
                                   </span>
                              </div>

                              <div class="col-12 col-md-6 mb-3 pe-md-2"
                                   [formGroup]="form">
                                   <label for="driverCity"
                                        class="form-label">
                                        <span [innerHtml]="'City' | translator: 'base'">
                                             City
                                        </span><span class="text-danger text-center ms-1"
                                             [title]="'Required' | translator: 'base'">*</span>
                                   </label>
                                   <input 
                                        formControlName="city"
                                        [title]="'City' | translator: 'base'"
                                        class="bg-light form-control"
                                        type="text"
                                        id="driverCity"
                                        name="driverCity"
                                        required
                                        maxLength="30"
                                   />
                                   <span *ngIf="city!.invalid && city!.dirty"
                                        class="help-block text-danger">
                                        <span *ngIf="city!.errors?.['required']"
                                             [innerHtml]="'City_required' | translator: 'base'">
                                             City is required.
                                        </span>
                                        <span *ngIf="city!.errors?.['pattern']"
                                             [innerHtml]="'City_invalid' | translator: 'base'">
                                             City contains invalid value(s). Please use only letters and numbers and
                                             these special characters: ' & - and spaces.
                                        </span>
                                        <span *ngIf="city!.errors?.['maxlength']"
                                             [innerHtml]="'City_max' | translator: 'base'">
                                             City must be 30 characters or less.
                                        </span>
                                   </span>
                              </div>

                              <div class="col-12 col-md-3 mb-3 px-md-2"
                                   [formGroup]="form">
                                   <label for="driverState"
                                        class="form-label">
                                        <span [innerHtml]="'State' | translator: 'base'">
                                             State
                                        </span><span class="text-danger text-center ms-1"
                                             [title]="'Required' | translator: 'base'">*</span>
                                   </label>
                                   <select 
                                        formControlName="state"
                                        class="form-select bg-light"
                                        [title]="'State' | translator: 'base'"
                                        id="driverState"
                                        name="driverState"
                                        required
                                   >
                                        <option value=""
                                             selected></option>
                                        <option *ngFor="let s of stateList"
                                             [ngValue]="s">{{ s }}</option>
                                   </select>
                                   <div *ngIf="state!.invalid && state!.dirty"
                                        class="help-block text-danger">
                                        <div *ngIf="state!.errors?.['required']"
                                             [innerHTML]="'State is required' | translator:'base'">
                                        </div>
                                   </div>
                              </div>

                              <div class="col-12 col-md-3 mb-3 ps-md-2"
                                   [formGroup]="form">
                                   <label class="form-label"
                                        for="driverZip">
                                        <span [innerHtml]="'Postal Code' | translator: 'base'">
                                             Postal Code
                                        </span><span class="text-danger text-center ms-1"
                                             [title]="'Required' | translator: 'base'">*</span>
                                   </label>
                                   <input size="10"
                                        [maxlength]="10"
                                        [minlength]="5"
                                        [title]="'Postal Code' | translator: 'base'"
                                        type="text"
                                        formControlName="zip"
                                        class="form-control bg-light w-100"
                                        id="driverZip"
                                        name="driverZip"
                                        placeholder="_____"
                                   />
                                   <span *ngIf="zip!.invalid && zip!.dirty"
                                        class="help-block text-danger">
                                        <span *ngIf="zip!.errors?.['required']"
                                             [innerHtml]="'PostalCode_required' | translator: 'base'">
                                             Postal code is required.
                                        </span>
                                        <span *ngIf="zip!.errors?.['pattern']"
                                             [innerHtml]="'PostalCode_invalid' | translator: 'base'">
                                             Please enter postal code in correct format.
                                        </span>
                                        <span *ngIf="zip!.errors?.['maxlength']"
                                             [innerHtml]="'PostalCode_max' | translator: 'base'">
                                             Postal code must be 10 characters or less.
                                        </span>
                                   </span>
                              </div>

                              <div class="col-12 col-md-6 mb-3 mb-md-0 pe-3 pe-md-2"
                                   [formGroup]="form">
                                   <label for="driverPhoneNumber"
                                        class="form-label">
                                        <span [innerHtml]="'Phone Number' | translator: 'base'">
                                             Phone Number
                                        </span><span class="text-danger text-center ms-1"
                                             [title]="'Required' | translator: 'base'">*</span>
                                   </label>
                                   <input 
                                        formControlName="phoneNumber"
                                        [title]="'Phone Number' | translator: 'base'"
                                        class="bg-light form-control"
                                        type="tel"
                                        id="driverPhoneNumber"
                                        name="driverPhoneNumber"
                                        placeholder="(___) ___-____"
                                        mask="(000) 000-0000"
                                        required
                                        minLength="14"
                                        maxLength="14"
                                   />
                                   <span *ngIf="phoneNumber!.invalid && phoneNumber!.dirty"
                                        class="help-block text-danger">
                                        <span *ngIf="phoneNumber!.errors?.['required']"
                                             [innerHtml]="'Phone_required' | translator: 'base'">
                                             Phone Number is required.
                                        </span>
                                        <span *ngIf="(phoneNumber!.errors?.['minlength'] || phoneNumber!.errors?.['maxlength'] || phoneNumber!.errors?.['pattern'])"
                                             [innerHtml]="'PhoneNumber_format' | translator: 'base'">
                                             Phone Number must be 10 digits.
                                        </span>
                                   </span>
                              </div>

                              <div class="col-12 col-md-6 mb-3 ps-3 ps-md-2"
                                   *ngIf="service.isReorder() === false"
                                   [formGroup]="form">
                                   <label for="driverAltPhone"
                                        class="form-label">
                                        <span *ngIf="service.justSubscribe === false" [innerHtml]="'AltPhoneNumber' | translator: 'base'">
                                             Alt Phone Number
                                        </span>
                                        <span *ngIf="service.justSubscribe === true" [innerHtml]="'driver_cell_phone_label' | translator: 'base'">
                                             Cell Phone Number
                                        </span>
                                   </label>
                                   <input 
                                        formControlName="altPhoneNumber"
                                        [title]="'AltPhoneNumber' | translator: 'base'"
                                        class="bg-light form-control"
                                        type="tel"
                                        id="driverAltPhone"
                                        name="driverAltPhone"
                                        placeholder="(___) ___-____"
                                        mask="(000) 000-0000"
                                        maxLength="14"
                                   />
                                   <span *ngIf="altPhoneNumber!.invalid && altPhoneNumber!.dirty"
                                        class="help-block text-danger"
                                        [innerHtml]="'PhoneNumber_format' | translator: 'base'">
                                        Phone Number must be 10 digits.
                                   </span>
                              </div>

                              <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                                   <div class="btn-group"
                                        role="group">
                                        <button 
                                             [routerLink]="wizard.continueLinkRoute(_step)"
                                             (click)="scrollToTop()"
                                             class="btn btn-primary btn-strong"
                                             [title]="'Continue' | translator: 'base'"
                                             [innerHtml]="'Continue' | translator: 'base'"
                                             [disabled]="form.status === 'INVALID'"
                                             name="driverNext"
                                             id="driverNext"
                                        >
                                             Continue
                                        </button>
                                   </div>

                                   <div class="btn-group"
                                        role="group">
                                        <button 
                                             [routerLink]="wizard.backLinkRoute(_step)"
                                             (click)="scrollToTop()"
                                             class="btn btn-outline-primary"
                                             [title]="'Back' | translator: 'base'"
                                             [innerHtml]="'Back' | translator: 'base'"
                                             name="driverBack"
                                             id="driverBack">
                                             Back
                                        </button>
                                        
                                        <button [routerLink]="wizard._cancelLinkRoute"
                                             tag="button"
                                             class="btn btn-light"
                                             (click)="scrollToTop()"
                                             name="driverCancel"
                                             id="driverCancel"
                                             [innerHtml]="'Cancel' | translator: 'base'"
                                             [title]="'Cancel' | translator: 'base'">
                                             Cancel
                                        </button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard 
          *ngIf="wizard"     
          [wizardObj]="wizard"
          [activeStep]="wizard.visualProgressStep(_step)" 
          pageType="driver"
          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>    
</div>